module.exports = __webpack_public_path__ + "img/pdf_02.bdade56d.svg";